import React from "react";
import { useState } from "react";
import Service from "../../services/user.service";
import { Button, Container, Textarea } from "@mantine/core";

var sumtext;
export const Home = () => {
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("typing");

  if (status === "success") {
    return<div><div className="head container"> <h1>Summary</h1></div><div className="container boox"> <Box style={{fontSize: '2rem', backgroundColor: '#333', borderRadius: 4, color: '#eee', minHeight: 200, padding: 12, width: 1500}}>{sumtext} </Box> </div></div> ;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("submitting");
    try {
      await submitForm(answer);
      setStatus("success");
    } catch (err) {
      setStatus("typing");
      setError(err);
    }
  }
  function Box({ children, ...props }) {
    return <div {...props}>{children}</div>
  }
  function handleTextareaChange(e) {
    setAnswer(e.target.value);
  }

  return (
    <>
      <h2 className="head">Summarizer</h2>
      <div className="input" >
      <Container style={{ width: 50 + "%" }} >
          <Textarea
            placeholder="NextParagraph will summarize your text. Start by writing or pasting something here and then press the summarize button."
            variant="filled"
            radius="xl"
            size="lg"
            autosize
            required
            minRows={10}
            value={answer}
            onChange={handleTextareaChange}
            disabled={status === "submitting"}
          />
          <br />
          <Button
          size="xl"
            onClick={handleSubmit}
            disabled={answer.length === 0 || status === "submitting"}
          >
            Summarize
          </Button>
          {error !== null && <p className="Error">{error.message}</p>}{" "}
        
      </Container>
      </div>
    </>
  );
};

async function submitForm(answer) {
  sumtext = await (await Service.summarize(answer)).data.summary;
  console.log(sumtext);
}
